import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getProfilePictureUrl } from "@/features/auth/authService";
import { getUserInitials } from "@/lib/userDisplay";
import { cn } from "@/lib/utils";

/**
 * A user's picture with initials behind it.
 *
 * The picture comes from the auth host's `/profile-picture` endpoint — the same
 * URL the account menu already used, keyed on guid, so no new API is involved.
 * It is a plain `<img src>` so the browser attaches the session cookie; on a
 * 404 or a cross-origin failure (localhost, where the cookie is not sent) the
 * avatar falls through to initials rather than showing a broken image.
 */
export function UserAvatar({ user, guid, size = "sm", className }) {
  const userGuid = guid ?? user?.guid;
  const pictureUrl = getProfilePictureUrl(userGuid);

  return (
    <Avatar size={size} className={cn("shrink-0", className)}>
      {pictureUrl && <AvatarImage src={pictureUrl} alt="" loading="lazy" />}
      {/* `!` beats a menu item's `focus:**:text-accent-foreground` — the
          initials sit on the avatar's own light circle, not the item's
          hover background, so they must never turn hover-white. */}
      <AvatarFallback className="text-[0.625rem] font-semibold text-foreground!">
        {getUserInitials(user)}
      </AvatarFallback>
    </Avatar>
  );
}
